import { FC } from 'react';

import cs from 'classnames';

import styles from './styles.module.scss';

interface AdvisorCardProps {
  name: string;
  location: string;
  image: string;
}

const AdvisorCard: FC<AdvisorCardProps> = ({ name, location, image }) => {
  return (
    <div className={styles.card}>
      <div className={cs(styles.imageWrapper, 'dashedBorder')}>
        <img src={image} alt={name} className={styles.image} />
      </div>
      <div className={styles.info}>
        <p className={styles.location}>{location}</p>
        <h4 className={styles.name}>{name}</h4>
      </div>
    </div>
  );
};

export default AdvisorCard;
